// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1021":"b7cbf4c9","1856":"376bbb15","4268":"89845316","5901":"31d6cfe0","7296":"b57e1b07"}[chunkId] + ".chunk.css";
};